import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

function PrivateRoute({ component: Component, roles, ...rest }) {
  const { student } = useSelector((state) => state);
  const { loading, isAuth } = student.studentAuth;
  return (
    <Route
      {...rest}
      render={(props) =>
        !loading && isAuth ? (
          <Component {...rest} {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/student/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
